import { render } from "./FormSuccess.vue?vue&type=template&id=4e5b2efe"
import script from "./FormSuccess.vue?vue&type=script&setup=true&lang=js"
export * from "./FormSuccess.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"source/js/vue/components/sections/FormSuccess.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4e5b2efe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4e5b2efe', __exports__)) {
    api.reload('4e5b2efe', __exports__)
  }
  
  module.hot.accept("./FormSuccess.vue?vue&type=template&id=4e5b2efe", () => {
    api.rerender('4e5b2efe', render)
  })

}


export default __exports__